// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"282ba78d","610":"d2613635","703":"806d31f6","787":"56f48a84"}[chunkId] + ".chunk.js";
};